import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { RatingContext } from './qualityAnalysis'
import { RatingBox } from './ratingBox'
import i18n from 'live/services/i18n'
import ConfirmationDialog from 'live/components/actions/ui/confirmation-dialog'
import { SensorialScale } from './sensorialScale'
import { motion, AnimatePresence } from 'framer-motion'

const containerVariants = {
    hidden: {
        height: 0,
        transition: {
            staggerChildren: 0.1,
            staggerDirection: -1
        }
    },
    visible: {
        height: 'auto',
        transition: {
            duration: 1,
            staggerChildren: 0.3,
            when: 'beforeChildren'
        }
    }
}

export const ratingBoxVariants = {
    hidden: { opacity: 0, y: '100vh' },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5 }
    }
}
interface IProps {
    renderConditional: boolean
}
export function QualityRating({ renderConditional }: IProps): JSX.Element {
    const { activeRatings } = useContext(RatingContext)
    const [showModal, setShowModal] = useState(false)

    return (
        <AnimatePresence>
            {renderConditional ? (
                <StyledQualityRating
                    className={`qualityRating`}
                    variants={containerVariants}
                    initial={'hidden'}
                    animate={'visible'}
                    exit={'hidden'}
                >
                    {activeRatings.length ? (
                        <>
                            <motion.div className="qualityRating--buttonContainer" variants={ratingBoxVariants}>
                                <button
                                    className={`qualityRating--buttonContainer__sensorialScaleButton`}
                                    onClick={() => setShowModal(true)}
                                >
                                    <i className="far fa-info-circle"></i> {i18n('Sensorial Scale')}
                                </button>
                            </motion.div>
                            {activeRatings.map(rating => (
                                <RatingBox ratingType={rating} key={rating} />
                            ))}
                        </>
                    ) : (
                        <div className="qualityRating--emptyMessage">
                            <p className="qualityRating--emptyMessage__icon">
                                <i className="far fa-empty-set"></i>
                            </p>
                            <p className="qualityRating--emptyMessage__header">
                                {i18n(`All of the analysis steps for rating are desabled`)}
                            </p>
                            <p className="qualityRating--emptyMessage__message">
                                {i18n(`To view analysis stps, please turn them on in configurations`)}
                            </p>
                        </div>
                    )}
                    <ConfirmationDialog
                        className="modal-lg"
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        title={i18n('Sensorial Scale')}
                        btnStyle={'primary'}
                        content={<SensorialScale />}
                        btnText={i18n('Close')}
                        apply={() => setShowModal(false)}
                        disableCancel={true}
                    />
                </StyledQualityRating>
            ) : null}
        </AnimatePresence>
    )
}

const StyledQualityRating = styled(motion.div)`
    padding-top: 10px;
    width: 100%;
    .qualityRating {
        &--buttonContainer {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            &__sensorialScaleButton {
                background: transparent;
                color: var(--blue-500);
                padding: 20px 0;
                font-size: 13px;
                border: none;
                font-family: var(--font-semibold);
                i {
                    margin-right: 8px;
                }
            }
        }
        &--emptyMessage {
            font-family: var(--font-semibold);
            margin: 8% 0;
            text-align: center;
            height: 100%;
            width: 100%;
            &__icon {
                color: var(--gray-500);
                font-size: 2rem;
                margin: 0;
            }
            &__header {
                color: var(--gray-800);
                margin: 0;
                font-weight: 900;
            }
            &__message {
                color: var(--gray-500);
                font-style: italic;
            }
        }
    }
`
